import axios from 'axios';
import { useCallback, useMemo, useState } from 'react';
import './index.css';

import ServicePaths from '../../../../bridge/utils/ServicePaths';

interface Props {
  botId: string;
  isActive: boolean;
}

const ActiveState: React.FC<Props> = (props: Props) => {
  const { isActive: initialIsActive, botId } = props;
  const [isActive, setIsActive] = useState(initialIsActive);
  const [formMessage, setFormMessage] = useState<
    { success: boolean; message: string } | undefined
  >();

  const isDisabled = useMemo(
    () => initialIsActive !== isActive,
    [initialIsActive, isActive],
  );

  const handleStartBot = useCallback(async () => {
    if (isActive || isDisabled) {
      return;
    }

    /** Call endpoint to start bot */
    const { data } = await axios({
      method: 'POST',
      url: ServicePaths.CONTROL.StartBot,
      params: {
        botId,
      },
    });

    setFormMessage(data);
    setIsActive(true);
  }, [botId, isActive, isDisabled]);

  const handleStopBot = useCallback(async () => {
    if (!isActive || isDisabled) {
      return;
    }

    /** Call endpoint to stop bot */
    const { data } = await axios({
      method: 'POST',
      url: ServicePaths.CONTROL.StopBot,
      params: {
        botId,
      },
    });

    setFormMessage(data);
    setIsActive(false);
  }, [botId, isActive, isDisabled]);

  return (
    <>
      {!!formMessage && (
        <p
          className={`active-state-message ${
            formMessage.success ? 'txc-green' : 'tcx-red'
          }`}
        >
          {formMessage.message}
        </p>
      )}
      <div className="active-state-container">
        <div
          className="active-state-button bg-green"
          style={{
            opacity: isDisabled || isActive ? 0.6 : 1,
            cursor: isDisabled || isActive ? 'default' : 'pointer',
          }}
          onClick={handleStartBot}
        >
          <span className="active-state-button-text">Start Bot</span>
        </div>
        <div
          className="active-state-button bg-red"
          style={{
            opacity: isDisabled || !isActive ? 0.6 : 1,
            cursor: isDisabled || !isActive ? 'default' : 'pointer',
          }}
          onClick={handleStopBot}
        >
          <span className="active-state-button-text">Stop Bot</span>
        </div>
      </div>
    </>
  );
};

export default ActiveState;
